import { Button, Dropdown } from 'antd';
import { useState } from 'react';

interface SelectedItem {
  label: string;
  key: string;
}

const items = [
  { label: 'Gemini', key: 'gemini' },
  { label: 'OpenAI', key: 'openai' },
  { label: 'Perplexity', key: 'perplexity' },
];
const ObjectiveAIDropdown = ({ onSelectModel }: any) => {
  const [selectedItem, setSelectedItem] = useState<SelectedItem | null>(null);

  const handleMenuClick = (e: any) => {
    const selected = items.find((item) => item.key === e.key);
    if (selected) {
      setSelectedItem(selected);
      onSelectModel(selected.key);
    }
  };
  return (
    <Dropdown menu={{ items, onClick: handleMenuClick }}>
      <Button onClick={handleMenuClick} style={{ width: '150px' }} type="default">
        {selectedItem?.label ?? 'Select AI Model'}
      </Button>
    </Dropdown>
  );
};

export default ObjectiveAIDropdown;
